(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var slider=document.getElementById('ss-gal-slider'),track=document.getElementById('ss-gal-track'),prev=document.getElementById('ss-gal-prev'),next=document.getElementById('ss-gal-next'),dots=document.getElementById('ss-gal-dots'),thumbs=document.getElementById('ss-gal-thumbs');
  if(slider&&track){
    var total=track.children.length,cur=0;
    var go=function(i){
      cur=Math.max(0,Math.min(i,total-1));
      track.style.transform='translateX(-'+(cur*100)+'%)';
      if(dots){Array.prototype.forEach.call(dots.children,function(d,j){d.classList.toggle('is-active',j===cur);});}
      if(thumbs){Array.prototype.forEach.call(thumbs.children,function(t,j){t.classList.toggle('is-active',j===cur);});}
      if(prev){prev.disabled=cur===0;}
      if(next){next.disabled=cur===total-1;}
    };
    if(prev){prev.addEventListener('click',function(){go(cur-1);});}
    if(next){next.addEventListener('click',function(){go(cur+1);});}
    if(thumbs){Array.prototype.forEach.call(thumbs.children,function(t,j){t.addEventListener('click',function(){go(j);});});}
    var sx=0,sy=0,drag=false,dx=0;
    var down=function(e){var p=e.touches?e.touches[0]:e;sx=p.clientX;sy=p.clientY;drag=true;dx=0;track.classList.add('no-tr');};
    var move=function(e){if(!drag){return;}var p=e.touches?e.touches[0]:e;dx=p.clientX-sx;if(Math.abs(dx)>Math.abs(p.clientY-sy)){if(e.cancelable){e.preventDefault();}track.style.transform='translateX(calc(-'+(cur*100)+'% + '+dx+'px))';}};
    var up=function(){if(!drag){return;}drag=false;track.classList.remove('no-tr');if(dx<-50){go(cur+1);}else if(dx>50){go(cur-1);}else{go(cur);}};
    slider.addEventListener('mousedown',down);
    slider.addEventListener('touchstart',down,{passive:true});
    window.addEventListener('mousemove',move);
    window.addEventListener('touchmove',move,{passive:false});
    window.addEventListener('mouseup',up);
    window.addEventListener('touchend',up);
    go(0);
  }
  var form=document.getElementById('ss-product-form'),btn=document.getElementById('ss-checkout-btn'),err=document.getElementById('ss-buy-err');
  if(form&&btn){
    var label=btn.innerHTML;
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var idEl=form.querySelector('[name="id"]'),qtyEl=form.querySelector('[name="quantity"]');
      var id=parseInt(idEl?idEl.value:btn.getAttribute('data-variant'),10);
      var qty=qtyEl?(parseInt(qtyEl.value,10)||1):1;
      btn.disabled=true;btn.innerHTML='Adding...';if(err){err.hidden=true;}
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty}]})})
        .then(function(r){return r.json();})
        .then(function(d){if(d.status&&d.status!==200){throw new Error(d.description);}window.location.href=root+'checkout';})
        .catch(function(){btn.disabled=false;btn.innerHTML=label;if(err){err.hidden=false;}});
    });
  }
  var bar=document.getElementById('ss-cartbar'),barTxt=document.getElementById('ss-cartbar-txt'),barX=document.getElementById('ss-cartbar-x');
  if(barX&&bar){barX.addEventListener('click',function(){bar.classList.remove('is-visible');});}
  if(bar){
    fetch(root+'cart.js').then(function(r){return r.json();}).then(function(c){
      if(c.item_count>0){barTxt.textContent=c.item_count+' item'+(c.item_count!==1?'s':'')+' in your cart';bar.classList.add('is-visible');}
    }).catch(function(){});
  }
})();